import { differenceInCalendarDays, format, formatDistanceToNowStrict, isPast } from "date-fns";

export const fmtDate = (iso) => (iso ? format(new Date(iso), "EEE d MMM, HH:mm") : "");
export const fmtDay = (d) => (d ? format(new Date(d), "d MMM yyyy") : "");
export const fromNow = (iso) => formatDistanceToNowStrict(new Date(iso), { addSuffix: true });
export const toLocalInput = (d) => format(d, "yyyy-MM-dd'T'HH:mm");

export const UNITS = [
  { value: 1, label: "minutes" },
  { value: 60, label: "hours" },
  { value: 1440, label: "days" },
  { value: 10080, label: "weeks" },
];

export function splitRepeat(minutes) {
  if (!minutes) return { every: 1, unit: 1440 };
  const unit = [...UNITS].reverse().find((u) => minutes % u.value === 0).value;
  return { every: minutes / unit, unit };
}

export function fmtRepeat(minutes) {
  if (!minutes) return "";
  const { every, unit } = splitRepeat(minutes);
  const name = UNITS.find((u) => u.value === unit).label;
  return every === 1 ? `every ${name.slice(0, -1)}` : `every ${every} ${name}`;
}

export function reminderState(r) {
  if (r.status === "done") return "done";
  if (!r.next_fire_at) return "sent";
  return isPast(new Date(r.next_fire_at)) ? "due" : "scheduled";
}

export function projectProgress(p) {
  if (p.status === "done") return 100;
  if (!p.start_date || !p.end_date) return null;
  const total = differenceInCalendarDays(new Date(p.end_date), new Date(p.start_date)) || 1;
  const done = differenceInCalendarDays(new Date(), new Date(p.start_date));
  return Math.max(0, Math.min(100, Math.round((done / total) * 100)));
}

export function daysLeft(p) {
  if (!p.end_date || p.status === "done") return null;
  return differenceInCalendarDays(new Date(p.end_date), new Date());
}
